var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100 d-inline-block"},[_c('div',{class:_vm.isProfitable ? 'triangle-up' : 'triangle-down'})])}
var staticRenderFns = []

export { render, staticRenderFns }